/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

import {StyleSheet} from 'aphrodite/no-important';

const styles = StyleSheet.create({
	formGroup: {
		marginBottom: "1rem"
	}
})

export default styles
